import { render, staticRenderFns } from "./DocContainer.vue?vue&type=template&id=606920de&scoped=true&"
import script from "./DocContainer.vue?vue&type=script&lang=js&"
export * from "./DocContainer.vue?vue&type=script&lang=js&"
import style0 from "./DocContainer.vue?vue&type=style&index=0&id=606920de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606920de",
  null
  
)

export default component.exports